import { motion } from "framer-motion";
import { ShieldCheck, HeartHandshake, BadgeDollarSign } from "lucide-react";
import { useText } from "../context/ContentContext";

const items = [
    {
        icon: ShieldCheck,
        title: "Quality, Vetted",
        body:
            "Every agent in our network is interviewed and evaluated for performance, professionalism, and local depth before they meet you.",
    },
    {
        icon: HeartHandshake,
        title: "Constant Support",
        body:
            "We don't refer and disappear. We stay in touch through the relationship to make sure you are getting what you need.",
    },
    {
        icon: BadgeDollarSign,
        title: "100% Free Service",
        body:
            "There is no cost to clients. Agents pay a referral fee from their commission — only when a transaction closes successfully.",
    },
];

export default function Benefits() {
    const title = useText("benefits_title", "Why Choose RealtorReferral.ca");
    return (
        <section
            className="bg-brand-paper"
            data-testid="benefits-section"
        >
            <div className="mx-auto max-w-7xl px-6 lg:px-10 py-24 lg:py-32">
                <div className="max-w-2xl mb-16">
                    <div className="text-xs uppercase tracking-[0.25em] text-brand-gold font-semibold mb-5">
                        — The Difference
                    </div>
                    <h2 className="font-serif text-4xl lg:text-5xl tracking-tight leading-tight text-brand-ink">
                        {title}
                    </h2>
                </div>

                <div className="grid md:grid-cols-3 gap-px bg-brand-line border border-brand-line">
                    {items.map((item, i) => {
                        const Icon = item.icon;
                        return (
                            <motion.div
                                key={item.title}
                                initial={{ opacity: 0, y: 24 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                viewport={{ once: true, margin: "-100px" }}
                                transition={{ duration: 0.6, delay: i * 0.15 }}
                                className="bg-brand-paper p-10 lg:p-12 group hover:bg-brand-sand/50 transition-colors"
                                data-testid={`benefit-card-${i}`}
                            >
                                <Icon
                                    size={32}
                                    strokeWidth={1.25}
                                    className="text-brand-gold mb-8 transition-transform group-hover:-translate-y-1"
                                />
                                <h3 className="font-serif text-2xl lg:text-3xl text-brand-ink mb-4 leading-tight">
                                    {item.title}
                                </h3>
                                <p className="text-brand-muted leading-relaxed">
                                    {item.body}
                                </p>
                            </motion.div>
                        );
                    })}
                </div>
            </div>
        </section>
    );
}
